import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import DisputeDetailsTable from "./Table/DisputeDetailsTable";
import CommercialAirlineNavigationBar from "../../../components/element/CommercialAirlineNavigationBar";
import ROUTE_PATHS from "../../../utils/routePaths";
import passengerDisputeCountLogo from "../../../assets/images/history-icon.svg";
import VerificationIcon from "../../../components/element/VerificationIcon";

const DisputeDetailsScreen = () => {
  const location = useLocation();
  const [disData, setDisData] = useState(null);

  useEffect(() => {
    // Try to get data from location.state first (normal navigation)
    if (location.state?.flightData) {
      setDisData(location.state.flightData);
    } else {
      // Fallback to sessionStorage (page refresh scenario)
      const savedFlightData = sessionStorage.getItem(
        "disputeDetailsFlightData"
      );

      if (savedFlightData) {
        try {
          const parsedData = JSON.parse(savedFlightData);
          setDisData(parsedData);
        } catch (error) {
          console.error("Error parsing saved flight data:", error);
        }
      }
    }
  }, [location.state]);

  return (
    <div>
      <div className="passenger-dispute-count-main-container">
        <CommercialAirlineNavigationBar
          title={"Passenger Disputed Details"}
          navigationLogo={passengerDisputeCountLogo}
          backContent={
            <div className="navigation-header">
              <Link
                to={ROUTE_PATHS.COMMERCIAL_AIRLINE_HOME}
                className="navigation-header-link"
              >
                Home/
              </Link>
              <Link
                to={ROUTE_PATHS.COMMERCIAL_AIRLINE_FLIGHT_ROSTER}
                className="navigation-header-link"
              >
                Disputed Flight Roster/
              </Link>
              Details
            </div>
          }
        />
       
        <DisputeDetailsTable disputeData={disData} />
      </div>
    </div>
  );
};

export default DisputeDetailsScreen;
